/**
 * Convert a Storyblok story link path to a named route object for the Link component.
 * Strips any locale prefix and builds { name: 'StoryblokPage', params: { slug, rest } }
 * so the Link component generates the correct locale-prefixed URL.
 *
 * @param {string} href - The path from Storyblok (e.g., "/terms-of-service" or "de/terms-of-service")
 * @param {string} locale - Current locale (e.g., "de")
 * @returns {{ name: string, params: { slug: string, rest: string } }} Named route object
 */
export const storyblokLinkToRoute = (href, locale) => {
  // Strip leading slash and locale prefix if present
  const cleaned = (typeof href === 'string' ? href : '')
    .replace(/^\//, '')
    .replace(new RegExp(`^${locale}/?`), '');

  const parts = cleaned.split('/');
  const slug = parts[0] || '';
  const rest = parts.slice(1).join('/');

  return {
    name: 'StoryblokPage',
    params: { slug, ...(rest ? { rest } : {}) },
  };
};
